import gql from "graphql-tag";

export const DELETE_SHEET_FROM_REPORT_MUTATION = gql`
  mutation DeleteSheetFromReport($reportId: ID!, $sheetId: ID!) {
    deleteSheetFromReport(reportId: $reportId, sheetId: $sheetId)
  }
`;
